import { ASSETS } from '../assets';
import { Project } from '../types/project';

export const PROJECTS_PREVIEW = [
  { id: 'arc', image: ASSETS.images.fireapp },
  { id: 'fireapp', image: ASSETS.images.arc },
  { id: 'twist', image: ASSETS.images.twist },
];

export const ALL_PROJECTS: Project[] = [
  {
    id: 'arc',
    name: 'Alrajhi Capital',
    screenshot: ASSETS.images.arc_logo,
    description: 'Role: Squad Tech Lead',
    impact: [
      'Led a React Native squad delivering Al Rajhi Capital, the top trading app in KSA.',
      'Coordinated with other teams to deliver features from sprint planning to production.',
      'Managed code reviews, production releases, and post-release support in a high-scale environment.',
    ],
    appStoreLink: 'https://apps.apple.com/us/app/alrajhi-capital/id6443600368',
    playStoreLink:
      'https://play.google.com/store/apps/details?id=com.alrajhicapital&pcampaignid=web_share',
  },
  {
    id: 'etisalatMusic',
    name: 'Twist Music',
    screenshot: ASSETS.images.twistLogo,
    description: 'Role: Sr. React-Native developer',
    impact: [
      'Contributed to the full rebranding and migration of the Etisalat Music app into Twist Music, now serving over 1M+ users.',
      'Developed and optimized complex features including media playback, offline caching and native features.',
      'Worked closely with designers and QA teams to ensure performance and UI/UX consistency across platforms.',
      'Assisted in resolving critical production issues and improving overall app stability.',
    ],
    playStoreLink:
      'https://play.google.com/store/apps/details?id=com.etisalat.music&pcampaignid=web_share',
    appStoreLink:
      'https://apps.apple.com/us/app/twist-music-podcast-radio/id1455541837',
  },
  {
    id: 'fireApp',
    name: 'Local 935',
    screenshot: ASSETS.images.fireApp,
    description: 'Role: Squad Tech Lead',
    impact: [
      'Led a major React Native upgrade, resolving multiple breaking changes and modernizing the project architecture.',
      'Implemented new application features and enhancements based on evolving business requirements.',
      'Stabilized the codebase and supported the application through testing, store preparation, and production release.',
    ],
    appStoreLink: 'https://apps.apple.com/us/app/local-935/id1570095222',
  },
  {
    id: 'rotary',
    name: 'Rotary D2451',
    screenshot: ASSETS.images.rotary,
    description: 'Role: Squad Tech Lead',
    impact: [
      'Developed an event management mobile application used by Rotary District 2451 to coordinate events and team activities.',
      'Implemented a multi‑role system with Admin and Team Member permissions for managing events, participants, and internal content.',
      'Built QR-based features allowing users to login and instantly access team member contact information by scanning QR codes.',
      'Implemented interactive team quizzes and event planning tools to enhance engagement and coordination during district activities.',
    ],
    appStoreLink: 'https://apps.apple.com/us/app/rotary-d2451/id1609857165',
  },
  {
    id: 'warshatna',
    name: 'Warshatna',
    screenshot: ASSETS.images.warshatna,
    description: 'Role: Squad Tech Lead',
    impact: [
      'Designed and developed the mobile application from scratch through production release, including architecture, core features, and deployment.',
      'Implemented a complex multi-role system supporting 8 different user types, each with dedicated flows, permissions, and tailored UI experiences.',
      'Built key platform features such as service requests, notifications, and role‑based dashboards.',
      'Led the full development lifecycle including technical planning, implementation, store deployment and post‑launch support.',
    ],
  },
  {
    id: 'priceShare',
    name: 'PriceShare',
    screenshot: ASSETS.images.priceShare,
    description: 'Role: Squad Tech Lead',
    impact: [
      'Developed a white‑label e‑commerce mobile application from scratch through production release.',
      'Built the platform so clients can customize branding including app name, icons, and identity after delivery.',
      'Implemented core e‑commerce features such as product browsing, cart management, checkout flows, and user accounts.',
      'Handled the full lifecycle including architecture, implementation, testing, and store deployment.',
    ],
  },
];
